import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { khoLeadApi } from '../../../api/khoLeadApi';
import { IKhoLeadFilter } from '../../../models/response/crm-survey/IKhoLead';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eKhoLeadActionTypeIds, IKhoLeadActionTypes } from '../../action-types/crm-survey/IKhoLeadActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* khoLeadSaga(): any {
    yield takeLatest(eKhoLeadActionTypeIds.LOAD_START, loadWorker);
    yield takeLatest(eKhoLeadActionTypeIds.LOAD_THONGKE_START, loadThongKeWorker);
    yield takeLatest(eKhoLeadActionTypeIds.LOAD_ROUNDROBIN_START, loadRoundRobinWorker);
    yield takeEvery(eKhoLeadActionTypeIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IKhoLeadActionTypes): any {
    const filter: IKhoLeadFilter = action.payload as IKhoLeadFilter;
    const res: IBaseResponeModel = yield call(khoLeadApi.select, filter);
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_SUCCESS(res.data ?? []));
    } else {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_ERROR(res.message ?? "Error"));
    }
}

function* loadThongKeWorker(action: IKhoLeadActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(khoLeadApi.selectThongKe, dm_coso_id);
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_THONGKE_SUCCESS(res.data ?? []));
    } else {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_THONGKE_ERROR(res.message ?? "Error"));
    }
}

function* loadRoundRobinWorker(action: IKhoLeadActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(khoLeadApi.selectRoundRobin, dm_coso_id);
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_ROUNDROBIN_SUCCESS(res.data ?? []));
    } else {
        yield put(actions.crmSurveyFormWrapper.khoLead.LOAD_ROUNDROBIN_ERROR(res.message ?? "Error"));
    }
}

function* deleteWorker(action: IKhoLeadActionTypes): any {
    const id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(khoLeadApi.delete, id);
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.khoLead.DELETE_SUCESS(undefined));
    } else {
        yield put(actions.crmSurveyFormWrapper.khoLead.DELETE_ERROR(res.message ?? "Error"));
    }
}
